class LuminomoProductShare extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;

    this.initialized = true;
    this.copyButton = this.querySelector('[data-share-copy]');
    this.shareLinks = this.querySelectorAll('[data-share-service]');
    this.feedback = this.querySelector('[data-share-feedback]');
    this.copyTimeout = undefined;

    this.handleCopy = this.handleCopy.bind(this);
    this.syncLinks = this.syncLinks.bind(this);

    this.copyButton?.addEventListener('click', this.handleCopy);
    this.shareLinks.forEach((link) => link.addEventListener('click', this.syncLinks));
    this.syncLinks();
  }

  disconnectedCallback() {
    this.copyButton?.removeEventListener('click', this.handleCopy);
    this.shareLinks?.forEach((link) => link.removeEventListener('click', this.syncLinks));
    clearTimeout(this.copyTimeout);
  }

  getShareUrl() {
    const currentUrl = new URL(window.location.href);
    currentUrl.hash = '';

    return currentUrl.href || this.dataset.shareUrl || '';
  }

  getShareImage() {
    const image = this.dataset.shareImage || '';

    if (!image) return '';

    try {
      return new URL(image, window.location.origin).href;
    } catch (_error) {
      return image;
    }
  }

  syncLinks() {
    const url = this.getShareUrl();
    const title = this.dataset.shareTitle || document.title;
    const image = this.getShareImage();

    this.shareLinks.forEach((link) => {
      const service = link.dataset.shareService;
      const params = new URLSearchParams();

      if (service === 'facebook') {
        params.set('u', url);
        link.href = `https://www.facebook.com/sharer/sharer.php?${params.toString()}`;
      }

      if (service === 'twitter') {
        params.set('text', title);
        params.set('url', url);
        link.href = `https://twitter.com/intent/tweet?${params.toString()}`;
      }

      if (service === 'pinterest') {
        params.set('url', url);
        params.set('description', title);

        if (image) {
          params.set('media', image);
        }

        link.href = `https://pinterest.com/pin/create/button/?${params.toString()}`;
      }

      if (service === 'whatsapp') {
        params.set('text', `${title} ${url}`);
        link.href = `https://api.whatsapp.com/send?${params.toString()}`;
      }
    });
  }

  async handleCopy() {
    const url = this.getShareUrl();

    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(url);
      } else {
        this.copyWithTextarea(url);
      }

      this.showCopied();
    } catch (_error) {
      this.copyWithTextarea(url);
      this.showCopied();
    }
  }

  copyWithTextarea(text) {
    const textarea = document.createElement('textarea');

    textarea.value = text;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'fixed';
    textarea.style.top = '0';
    textarea.style.left = '-9999px';

    document.body.append(textarea);
    textarea.select();
    document.execCommand('copy');
    textarea.remove();
  }

  showCopied() {
    this.classList.add('is-copied');
    clearTimeout(this.copyTimeout);

    this.copyTimeout = setTimeout(() => {
      this.classList.remove('is-copied');
    }, 1800);
  }
}

if (!customElements.get('luminomo-product-share')) {
  customElements.define('luminomo-product-share', LuminomoProductShare);
}
